export default "__VITE_ASSET__7b4664b3__"